import styles from "./taskdetails.module.css";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";
import dayjs from "dayjs";

const TaskCheckList = ({ taskCheckList, setTaskCheckList, onCheckList }) => {
  const [taskExpanded, setTaskExpanded] = useState("");

  const handleChange = (panel) => (event, isTaskExpanded) => {
    setTaskExpanded(isTaskExpanded ? panel : false);
  };

  const handleCheckToggle = (date, taskId, isChecked) => {
    const updatedList = taskCheckList.map((day) =>
      day.date === date
        ? {
            ...day,
            tasks: day.tasks.map((task) =>
              task.id === taskId
                ? { ...task, is_checked: task.is_checked ? 0 : 1 }
                : task
            ),
          }
        : day
    );
    setTaskCheckList(updatedList);

    onCheckList(taskId, !isChecked);
  };

  if (!taskCheckList || taskCheckList.length === 0) {
    return <div className={`${styles.NoDataMain}`}>
              <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/tasklist.svg" alt="" />
              </div>
              <p className={`${styles.NoDataText}`}>Woohoo!</p>
              <p className={`${styles.NoDataTextSub}`}>There are no checklist available.</p>
            </div>;
  }

  return (
    <>
      {taskCheckList.map((day, index) => {
        const completedCount = day.tasks.filter((t) => t.is_checked).length;
        const totalCount = day.tasks.length;

        return (
          <Accordion
            key={day.date}
            expanded={taskExpanded === `panel-${index}`}
            onChange={handleChange(`panel-${index}`)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${index}-content`}
              id={`panel-${index}-header`}
            >
              <div className={styles.FormAccoHead}>
                <p className={styles.FormAccoHeadTitle}>
                  <span>Task Date</span> {dayjs(day.date).format("MM/DD/YYYY")}
                </p>
                <p className={styles.FormAccoHeadSubTitle}>
                  <span>Completed Tasks</span>
                  {completedCount}/{totalCount}
                  {completedCount < totalCount && (
                    <img src="/static/img/warning.png" alt="warning" />
                  )}
                  {completedCount === totalCount && (
                    <img src="/static/img/success.png" alt="Completed" />
                  )}
                </p>
              </div>
            </AccordionSummary>
            <AccordionDetails className={styles.CussAccoRow}>
              <div className={styles.TaskCheckSec}>
                {day.tasks.map((task) => (
                  <div key={task.id} className={styles.TaskCheckList}>
                    <FormControlLabel
                      className={styles.ProsCheckSec}
                      control={
                        <Checkbox
                          checked={!!task.is_checked}
                          onChange={() =>
                            handleCheckToggle(
                              day.date,
                              task.id,
                              task.is_checked
                            )
                          }
                        />
                      }
                      label={
                        task.is_checked ? (
                          <del>{task.task_list}</del>
                        ) : (
                          task.task_list
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default TaskCheckList;
